import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { AccountingTabLabelComponent } from '../../shared/accounting-tab-label.component';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { PageHeroComponent } from '../../../shared/page-layout/page-hero.component';
import { PageMetricStripComponent } from '../../../shared/page-layout/page-metric-strip.component';
import { PageShellComponent } from '../../../shared/page-layout/page-shell.component';
import { PageMetric } from '../../../shared/page-layout/page-layout.models';

interface VendorStatementRow {
    statementNumber: string;
    vendorName: string;
    statementDate: Date;
    statementAmount: number;
    matchedAmount: number;
    differenceAmount: number;
    status: string;
}

@Component({
    selector: 'app-vendor-statement-reconciliation',
    standalone: true,
    imports: [CommonModule, FormsModule, ButtonModule, InputTextModule, TableModule, TabsModule, TagModule, AccountingTabLabelComponent, PageShellComponent, PageHeroComponent, PageMetricStripComponent, PageDataPanelComponent],
    templateUrl: './vendor-statement-reconciliation.component.html',
    styleUrls: ['./vendor-statement-reconciliation.component.css']
})
export class VendorStatementReconciliationComponent {
    activeTab = 'list';
    vendorFilter = '';
    rows: VendorStatementRow[] = [];
    selected?: VendorStatementRow;

    metrics: PageMetric[] = [
        { label: 'Imported Statements', value: 0, hint: 'Import API pending', tone: 'info' },
        { label: 'Matched Amount', value: this.money(0), tone: 'success' },
        { label: 'Differences', value: this.money(0), tone: 'warn' },
        { label: 'Open Exceptions', value: 0, tone: 'danger' }
    ];

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.route.queryParamMap.subscribe(params => {
            this.activeTab = this.resolveTab(params.get('tab'));
        });
    }

    get filteredRows(): VendorStatementRow[] {
        const filter = this.vendorFilter.trim().toLowerCase();
        return filter ? this.rows.filter(row => row.vendorName.toLowerCase().includes(filter)) : this.rows;
    }

    select(row: VendorStatementRow): void {
        this.selected = row;
        this.setActiveTab('detail');
    }

    setActiveTab(value: string | number): void {
        this.activeTab = this.resolveTab(String(value));
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab: this.activeTab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    money(amount?: number, currency = 'SAR'): string {
        return `${currency} ${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`;
    }

    severity(status?: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
        if (status === 'MATCHED') return 'success';
        if (status === 'IMPORTED') return 'info';
        if (status === 'DIFFERENCE') return 'warn';
        if (status === 'EXCEPTION') return 'danger';
        return 'secondary';
    }

    private resolveTab(value: string | null): string {
        return ['list', 'detail', 'activity'].includes(value || '') ? String(value) : 'list';
    }
}
